var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmeFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.886 427c11.813 0 22.782-4.641 31.22-13.079l189.43-189.43c7.594-7.594 12.235-18.142 12.235-29.111v-2.109c0-10.97-4.219-21.517-12.235-29.111l-72.987-71.722C398.064 86.953 390.892 84 383.298 84H128.474c-7.595 0-14.767 2.953-20.251 8.438L35.235 164.16C27.219 171.754 23 182.301 23 193.271v2.109c0 10.969 4.219 21.517 12.235 29.111l189.43 189.43c8.016 8.438 19.408 13.079 31.221 13.079z",
    fill: "url(#prefix__paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.521 84v.422c8.437 0 16.453 2.953 22.36 8.438l85.644 77.206c4.641 4.219 10.548 6.329 16.876 6.329h10.126c6.328 0 12.235-2.532 16.875-6.329l85.645-77.206c6.328-5.485 14.344-8.438 22.36-8.438V84H125.521z",
    fill: "#2C2A7A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1862.24773 -79.64287 63.63226 1487.87994 242.513 291.607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2E60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2E60",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmeFlat);
export default __webpack_public_path__ + "static/media/ame-flat.12966c2f27e23e133d5d02ee8231c625.svg";
export { ForwardRef as ReactComponent };